module.exports = "  <div *ngIf=\"message.length > 0\"  class=\"row bg-danger\" style=\"height: 50px;\">\n    <div class=\"col-sm-12 text-white text-center my-auto\" [innerHTML]=\"message | safeHtml\">\n           \n    </div>\n  </div>\n  \n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/announcement-show/announcement-show.component.html
// module id = 465
// module chunks = 0